export default __webpack_public_path__ + "static/heatmap_widget-30bd91442d64eb84b88263090dabe6c6.webp";